import React from "react";
import "./index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";

import find from "lodash/find";


/**
 * This component is a simple select box, generally used for applying a filter. 
 */
function HeSelect(props){

    return (
        <div className="HeSelect">
            <select
                disabled={props.disabled}
                className={(props.defaultStyle?'defaultSelect':'')+(props.disabled?' disabled':'')}
                value={props.selected}
                onChange={function(evt) {
                    props.onChange(
                        find(props.data,(item)=>{
                            return item.value.toString() === evt.currentTarget.value.toString();
                        })
                    );
                }}
            >
                {props.data.map((item, index) => (
                    <option key={index} value={item.value}>
                        {item.label}
                    </option>
                ))}
            </select>
            {props.defaultStyle?<FontAwesomeIcon icon={faChevronDown} className="HeSelect-fa" />:null}
        </div>
    );
}

HeSelect.propTypes = {
    /** An array of objects */
    data: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,
        })
    ).isRequired,

    /** If this is not provided the first item in the list will be chosen */
    selected: PropTypes.string.isRequired,

    disabled: PropTypes.bool,

    /** A function that will run when the a selection is made */
    onChange: PropTypes.func.isRequired,

    /** Custom styling */
    customClass: PropTypes.string,

    defaultStyle:PropTypes.bool
};
HeSelect.defaultProps = {
    customClass: "",
    defaultStyle: true,
    disabled:false
};

export default HeSelect;